import { WalletType } from "@/interfaces/IUser";
import { config } from "@/sahara-core-config";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from "web3";

let provider: any = {};
let web3 : any;
const RPCUrl = "https://rpc-mumbai.maticvigil.com/v1/3e6fbf872f3d8a58d8a0ad233b2dea81db1c879f";

const checkWeb3Instance = async () /*: Promise<Web3>*/ => {
    const w = (window as unknown) as Window & { ethereum: any; web3: Web3 };
    if (w.ethereum) {
        //Injected ethereum
        const web3 = new Web3(w.ethereum)
        //Allow access to the account.
        return w.ethereum.enable().then(() => {
          return web3;
        });
      
    } else if (w.web3) {
        //Injected web3
        return new Web3(w.web3.currentProvider);
    }
    console.log("Metamask not found.")
    // throw Error("Web3 not found");
    };

const getWeb3 = () => {
return new Promise<Web3>((resolve, reject) => {
    if (document.readyState === "complete") {
    return checkWeb3Instance()
        .then(resolve)
        .catch(reject);
    }

    // Wait for loading completion.
    window.addEventListener(`load`, () => {
        checkWeb3Instance()
        .then(resolve)
        .catch(reject);
    });
});
};

const checkNetworkChange = async (chainID : string, networkId : number): Promise<any> =>{
    const w = (window as unknown) as Window & { ethereum: any; web3: Web3 };
    if (w.ethereum) {
        try {
          await w.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: chainID }], // option.chainID
          });
        } catch (error : any) {
          if (error.code === 4902) {
            let chainName;
            let metamaskRPCUrls;
            let metamaskBlockExplorerUrls;

            const web3 = new Web3(w.web3.currentProvider);
            const chainIDHex = web3.utils.toHex(networkId);
            
            if(networkId == 137){

              chainName = 'Polygon'
              metamaskRPCUrls = ['https://polygon-rpc.com']
              metamaskBlockExplorerUrls = ['https://www.polygonscan.com']

            } else if (networkId == 80001) {

              chainName = 'Mumbai'
              metamaskRPCUrls = ['https://rpc-mumbai.maticvigil.com']
              metamaskBlockExplorerUrls = ['https://mumbai.polygonscan.com/']

            }

            try {
        await w.ethereum.request({
                method: 'wallet_addEthereumChain',
                chainName: chainName,
                params: [{
                  chainId: chainIDHex,
                  chainName: chainName,
                  nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
                  rpcUrls: metamaskRPCUrls,
                  blockExplorerUrls: metamaskBlockExplorerUrls,
              }]
              });
            } catch (addError) {
              console.error(addError);
            }
          }
          console.error(error);
        }
      } else {
        // if no window.ethereum then MetaMask is not installed
        console.log('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
      } 
}
    
const getWalletConnectProvider = async ()=> {
      provider = await new WalletConnectProvider({
        rpc: {
          80001: config.deployments[80001].rpcURL,
          137: config.deployments[137].rpcURL,
          1: config.deployments[1].rpcURL
        },
        // chainId: 3,
        pollingInterval: 15000000,
        qrcode: true,
      });

      // provider.networkId = 3;
      try{
        await provider.enable();
      } catch (error) {
        console.log("Modal closed")
      }
      return provider;
    
  }

const changeNetwork = (chainID : string, networkId : number) => {
    return new Promise<Web3>((resolve, reject) => {
        if (document.readyState === "complete") {
        return checkNetworkChange(chainID, networkId)
            .then(resolve)
            .catch(reject);
        }

        // Wait for loading completion.
        window.addEventListener(`load`, () => {
            checkNetworkChange(chainID, networkId)
            .then(resolve)
            .catch(reject);
        });
    });
    };

// TODO: merge into getWeb3Instance
async function getWeb3Provider(walletType : any){
  if(walletType == WalletType.METAMASK){
    const w = window as unknown as Window & { ethereum: any; web3: Web3 };
    // console.log("Metamask")
    try { 
      let web3  = await new Web3(RPCUrl);
      if (w.ethereum) {
        // console.log("metamask")
        web3 = await new Web3(w.ethereum);
        //TODO: optimize
        const accounts = await web3.eth.getAccounts();
        if(accounts.length != 0){
          return web3
        }
      } 
    } catch (error) {
      console.error(error);
    }
  } else if (walletType == WalletType.WALLETCONNECT){
    // console.log("WalletConnect")
    //Metamask not connected or not logged on. Trying wallet connect.
    const provider = await getWalletConnectProvider();    
      if(provider){
        const web3 = await new Web3(provider);
        const accounts = await web3.eth.getAccounts();
        if(accounts.length != 0){
          return web3
        }
      }
  }
  // console.log("Default RPC")
  //Neither metamask nor wallet connect is connected.
  const defaultRPC = await new Web3(config.deployments[80001].rpcURL);

  return defaultRPC;
}

export {
    getWeb3,
    changeNetwork,
    checkWeb3Instance,
    getWalletConnectProvider,
    getWeb3Provider
};
